/**
 * Systèmes de cotation pour le ski de randonnée
 * Ces constantes doivent être synchronisées avec celles dans SkiTouringFilters.tsx
 */
export const SKI_RATING_SYSTEM: readonly string[] = [
  '1.1', '1.2', '1.3',
  '2.1', '2.2', '2.3',
  '3.1', '3.2', '3.3',
  '4.1', '4.2', '4.3',
  '5.1', '5.2', '5.3', '5.4', '5.5', '5.6'
];

export const SKI_EXPOSITION_SYSTEM: readonly string[] = ['E1', 'E2', 'E3', 'E4'];

export const SKI_GLOBAL_RATING_SYSTEM: readonly string[] = [
  'F', 'F+',
  'PD', 'PD+',
  'AD', 'AD+',
  'D', 'D+',
  'TD', 'TD+',
  'ED1', 'ED2', 'ED3', 'ED4', 'ED5', 'ED6', 'ED7'
];

export const SKI_PUNCTUAL_RATING_SYSTEM: readonly string[] = ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7'];
